/**
 * AUTO-GENERATED from schema.json — DO NOT EDIT
 * Source: Hero (hero)
 * Run `yarn workspace @library/cms-blocks cms:types` to regenerate
 */

import { z } from 'zod'
import { CmsAssetSchema, RichTextContentSchema } from '../../types/contentstack-zod'
import { RawCmsCtaSchema } from '../../cta'

export const HeroFieldsSchema = z
  .object({
    heading: z.string().max(80),
    body: RichTextContentSchema.nullish(),
    cta: RawCmsCtaSchema.nullish(),
    image: CmsAssetSchema.nullish(),
    image_mobile: CmsAssetSchema.nullish(),
    image_alt: z.string().nullish(),
  })
  .passthrough()
